import AuthService from "../../services/auth-service";
import router from "../../router";
import axios from 'axios';

export default {
	// Lógica del auth
	async login({ commit }, payload) {
		let user = payload.Usuario

		let res = await AuthService.login(user);
		let auxPayload = payload
		if(res.IsOk === true){
			auxPayload = {
				Usuario: res.Usuario,
				OrganizadorActivo: res.OrganizadorActivo
			}
			commit("login", auxPayload);
		} else {
			commit("logout");
		}
		
		return res
	},
	loginAuto({ commit }, payload) {
		localStorage.setItem("user", JSON.stringify(payload.Usuario));
		if(Number(payload.OrganizadorActivo) > 0){
			localStorage.setItem('or_ac', payload.OrganizadorActivo);
		}
		commit("login", payload);
	},
	logout({ commit }) {
		if (router.currentRoute.name !== "home") {
			router.push({ name: "home" });
		}
		AuthService.logout();
		commit("logout");
	},
	register({ commit }, user) {
		return AuthService.register(user).then(
			(response) => {
				commit("registerSuccess");
				return Promise.resolve(response.data);
			},
			(error) => {
				commit("registerFailure");
				return Promise.reject(error.response.data);
			}
		);
	},
	showAuthModal({ commit }, payload) {
		commit("UPDATE_AUTH_MODAL_VISIBILITY", {
			visibility: true,
			callbackAction: payload.callbackAction,
		});
	},
	hideAuthModal({ state, commit }, clearCallbackAction) {
		if (clearCallbackAction) {
			commit("UPDATE_AUTH_MODAL_VISIBILITY", {
				visibility: false,
				callbackAction: {
					name: null,
					payload: null,
				},
			});
		} else {
			commit("UPDATE_AUTH_MODAL_VISIBILITY", {
				visibility: false,
				callbackAction: state.authModal.callbackAction,
			});
		}
	},
	updateCallbackAction({ commit }, payload) {
		commit("UPDATE_AUTH_MODAL_VISIBILITY", {
			callbackAction: payload.callbackAction,
			visibility: false,
		});
	},
	redirigirA({}, payload) {
		if (router.currentRoute.name !== payload.route) {
			router.push({ name: payload.route, params: payload.params });
		}
	},
	redirigirAWithReload({}, payload) {
		if (router.currentRoute.name !== payload.route) {
			router.push({ name: payload.route, params: payload.params });
		} else {
			location.reload();
		}
	},
	// async crearTransaccionYRedirigirA({ state, dispatch }, payload){
	// 	try {
	// 		let response = await axios.post('/WSTransaccion', {
	// 			TransaccionMedio: payload.trn.TransaccionMedio, 
	// 			UsuarioId: state.user.UsuarioId,
	// 			TransaccionEventoId: payload.trn.TransaccionEventoId,
	// 			TransaccionEventoTribunaId: payload.trn.TransaccionEventoTribunaId,
	// 			TransaccionEventoSectorCod: payload.trn.TransaccionEventoSectorCod,
	// 			TransaccionCantidad: payload.trn.TransaccionCantidad,
	// 			SDTFilaAsientoJSON: JSON.stringify(payload.trn.FilasAsientos),
	// 		}, { headers: {"Authorization" : `Bearer ${ state.user.AccessToken }`} });

	// 		if(response.data.ErrorCod === 0){
	// 			let transaccionId = response.data.TransaccionId

	// 			// Armo objeto Checkout
	// 			let checkout = {
	// 				TransaccionId: transaccionId,
	// 				EventoId: payload.trn.TransaccionEventoId,
	// 				// TribunaId: payload.trn.TransaccionEventoTribunaId,
	// 				// TribunaNombre: payload.trn.TransaccionEventoTribunaNombre,
	// 				// Sector: payload.trn.Sector,
	// 				// CantidadTotal: payload.trn.TransaccionCantidad,
	// 				Segmentos: payload.trn.Segmentos,
	// 				TicketsUbicaciones: payload.trn.TicketsUbicaciones,
	// 				Moneda: payload.trn.Moneda
	// 			}

	// 			dispatch('setearCheckout', checkout, {root:true})

	// 			if (router.currentRoute.name !== payload.route) {
	// 				router.push({ name: payload.route, params: payload.params });
	// 			}
	// 		} else {
	// 			if(response.data.ErrorCod === 1 || response.data.ErrorCod === 20 || response.data.ErrorCod === 21){
	// 				dispatch('logout');
	// 			} else {
	// 				dispatch('showError', 'Ocurrió un error. Intenta nuevamente.', {root:true});
	// 				router.push({ name: 'home' });
	// 			}
	// 		}
	// 	} catch (error) {
	// 		dispatch('showError', 'Ocurrió un error. Intenta nuevamente.', {root:true});
	// 		router.push({ name: 'home' });
	// 	}
	// },
	setOrganizadorActivo({ commit }, orAc) {
		if(Number(orAc) > 0){
			localStorage.setItem('or_ac', orAc);
		}
		commit("setOrganizadorActivo", orAc);
	},
};